// import React, { useEffect, useState } from "react";
// import BreadcrumbArrow from "../../assets/images/breadcrumb-image-arrow.svg";
// import ProfileImage from "../../assets/images/profile-image.png";
// import GammingHeadIcon from "../../assets/images/game-rank-icon/gamming-headshot.svg";
// import CommentedIcon from "../../assets/images/game-rank-icon/commented-icon.svg";
// import FifaIcon from "../../assets/images/game-rank-icon/fifa-ball-icon.svg";
// import Callicon from "../../assets/images/game-rank-icon/call-of-ducty-icon.svg";
// import { Breadcrumb, Button, Input } from "antd";
// import { shareProfile } from "../../utils/share";

// import ShareIcon from "../../assets/images/share-icon.svg";
// import { Ellipsis, Heart, MessageCircle } from "lucide-react";
// import { useNavigate, useParams } from "react-router";
// import Main from "../../components/layout/Main";
// import { useAuth } from "../../context/AuthContext";
// import { isValidUrl } from "../../helper/functions";
// import { Severty, ShowToast } from "../../helper/toast";
// import TextArea from "antd/lib/input/TextArea";
// import { HeartFilled } from "@ant-design/icons";
// import moment from "moment";
// import ShareModal from "../../components/ShareModal";

// function ConnectionProfileSec() {
//   // --------- constants ----------
//   const navigate = useNavigate();
//   const {
//     getProfileById,
//     followUser,
//     unfollowUser,
//     getPosts,
//     likePost,
//     createComment,
//   } = useAuth();
//   const [profile, setProfile] = useState();
//   const [commentInputPostId, setCommentInputPostId] = useState(false);
//   const [comment, setComment] = useState("");
//   const [posts, setPosts] = useState([]);
//   const [shareOpen, setShareOpen] = useState(false);

//   const { id } = useParams();

//   // --------- handlers -----------
//   const fetchProfile = async (id) => {
//     try {
//       const response = await getProfileById(id);
//       if (response.status === 200) {
//         setProfile(response.data);
//       }
//       const result = await getPosts();
//       if (result.status === 200) setPosts(result.data.data);
//     } catch (error) {
//       console.log("Error Ocurred when fetch profile", error);
//     }
//   };

//   //---------- follow user ------------
//   const handleFollow = async (id, isFollowing) => {
//     try {
//       let response;
//       if (isFollowing) {
//         response = await unfollowUser(id);
//       } else {
//         response = await followUser(id);
//       }
//       if (response.status === 200) {
//         fetchProfile(id);
//       }
//     } catch (error) {
//       console.log("Error Ocurred when fetch profile", error);
//     }
//   };

//   // ---------- Handle comment ----------
//   const handleCommentPost = async (postId, content) => {
//     try {
//       const response = await createComment(postId, content);
//       if (response.status === 200) {
//         ShowToast(response.message, Severty.SUCCESS);
//         fetchProfile(id);
//         setCommentInputPostId(false);
//         setComment("");
//       }
//     } catch (error) {
//       console.log("error in handle comment post -->", error);
//       ShowToast(error.message, Severty.ERROR);
//     }
//   };

//   // ---------- Handle Like -------------
//   const handleLikePost = async (postId) => {
//     // console.log("postId-->", postId);
//     // setIsLiked((prev) => !prev);
//     try {
//       const response = await likePost(postId);
//       if (response.status === 200) {
//         fetchProfile(id);
//       }
//     } catch (error) {
//       console.log("error in handle like post -->", error);
//       ShowToast(error.message, Severty.ERROR);
//     }
//   };

//   // --------- use effect ----------
//   useEffect(() => {
//     fetchProfile(id);
//   }, [id]);

//   // --------- Go to the specifi post -----------
//   useEffect(() => {
//     if (window.location.hash) {
//       const postId = window.location.hash.replace("#", "");

//       // Wait for posts to load
//       setTimeout(() => {
//         const element = document.getElementById(postId);
//         if (element) {
//           element.scrollIntoView({ behavior: "smooth", block: "start" });
//         }
//       }, 300);
//     }
//   }, [posts]);

//   return (
//     <Main>
//       <section className="profile-section">
//         <Breadcrumb
//           className="for-route-path-head"
//           separator={<img src={BreadcrumbArrow} alt=">" />}
//         >
//           <Breadcrumb.Item
//             onClick={() => navigate("/connections")}
//             style={{ cursor: "pointer" }}
//           >
//             Connections
//           </Breadcrumb.Item>
//           <Breadcrumb.Item>{profile?.name}</Breadcrumb.Item>
//         </Breadcrumb>

//         {/* Profile Picture & Stats */}
//         <div className="profile-header">
//           <div className="avatar-wrapper">
//             <img
//               src={
//                 isValidUrl(profile?.profilePic)
//                   ? profile?.profilePic
//                   : ProfileImage || ProfileImage
//               }
//               alt="avatar"
//             />
//           </div>
//           <div className="stats">
//             <div className="stat-block">
//               <h6 className="count">{profile?.followersCount}</h6>
//               <span className="label">Followers</span>
//             </div>
//             <div className="stat-block">
//               <h6 className="count">{profile?.followingCount}</h6>
//               <span className="label">Following</span>
//             </div>
//           </div>
//         </div>

//         {/* Name and Handle */}
//         <div className="username">
//           <h6 className="name">{profile?.name}</h6>
//           <span className="handle">@{profile?.userId}</span>
//         </div>

//         {/* Action Buttons */}
//         <div className="profile-actions">
//           <Button
//             className="btn-fill-small active"
//             onClick={() => handleFollow(profile?._id, profile?.IsFollowing)}
//           >
//             {profile?.IsFollowing ? "Unfollow" : "Follow"}
//           </Button>
//           <Button
//             className="btn-fill-small"
//             onClick={() => navigate("/chat", { state: { profile } })}
//           >
//             Message
//           </Button>
//           <Button
//             className="btn-fill-small"
//             onClick={() => {
//               const url = `${window.location.origin}/profile/${profile?._id}`;

//               if (navigator.share) {
//                 shareProfile(url); // mobile
//               } else {
//                 setShareOpen(true); // desktop modal
//               }
//             }}
//           >
//             Share Profile
//           </Button>
//         </div>

//         {/* Game Ranks & Recent Activity */}
//         <div className="info-panels">
//           {/* Game Ranks */}
//           <div className="panel game-ranks">
//             <h6 className="panel-title">Game Ranks</h6>

//             <div className="game-row">
//               <div className="game-info">
//                 <img src={Callicon} alt="call of duty" />
//                 <div>
//                   <h6 className="game-title">Call of Duty</h6>
//                   <span className="game-level">Master Level</span>
//                 </div>
//               </div>
//               <h6 className="game-rank">#12</h6>
//             </div>

//             <div className="game-row">
//               <div className="game-info">
//                 <img src={FifaIcon} alt="fifa 2025" />
//                 <div>
//                   <h6 className="game-title">FIFA 2025</h6>
//                   <span className="game-level">Elite Division</span>
//                 </div>
//               </div>
//               <h6 className="game-rank">#42</h6>
//             </div>
//           </div>

//           {/* Recent Activity */}
//           <div className="panel recent-activity">
//             <h6 className="panel-title">Recent Activity</h6>

//             <div className="activity-row">
//               <img src={GammingHeadIcon} alt="activity" />
//               <div>
//                 <h6 className="activity-text">
//                   Won auction for Gaming Headset
//                 </h6>
//                 <span className="activity-time">2 hours ago</span>
//               </div>
//             </div>

//             <div className="activity-row">
//               <img src={CommentedIcon} alt="activity2" />
//               <div>
//                 <h6 className="activity-text">
//                   Commented on "Gaming Tips 101"
//                 </h6>
//                 <span className="activity-time">2 hours ago</span>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Post Card */}
//         {posts &&
//           posts.map((post, index) => {
//             return (
//               <div className="post-card" key={index} id={post._id}>
//                 <div className="post-header">
//                   <div className="post-user">
//                     <img
//                       src={post?.profilePic || ProfileImage}
//                       alt={post?.name}
//                     />
//                     <div>
//                       <h6 className="post-name">{post?.name}</h6>
//                       <span className="post-date">
//                         {moment(post.updated_at).format("MMMM, D YYYY")}
//                       </span>
//                     </div>
//                   </div>
//                   {/* <Button className="more-button">
//                     <Ellipsis />
//                   </Button> */}
//                 </div>
//                 <div className="post-content">
//                   <p>{post?.body}</p>
//                 </div>
//                 <div className="games-connections-input">
//                   <img src={CommentedIcon} alt="activity2" />
//                   {/* <Input className="connections-input" disabled /> */}
//                 </div>
//                 <div className="post-reactions">
//                   <div className="reaction-group">
//                     <div
//                       className="reaction"
//                       onClick={() => handleLikePost(post?._id)}
//                       style={{ cursor: "pointer" }}
//                     >
//                       {post?.isLiked ? (
//                         <HeartFilled style={{ fontSize: 22, color: "red" }} />
//                       ) : (
//                         <Heart />
//                       )}
//                       <span>{post?.totalLikes}</span>
//                     </div>
//                     <div className="reaction">
//                       <MessageCircle
//                         onClick={() =>
//                           setCommentInputPostId((prev) =>
//                             prev === post._id ? null : post._id
//                           )
//                         }
//                         style={{ cursor: "pointer" }}
//                       />
//                       <span>{post?.totalComments}</span>
//                     </div>
//                   </div>
//                   <div
//                     onClick={() => {
//                       const url = `${window.location.origin}/profile/${profile?._id}/#${post._id}`;

//                       if (navigator.share) {
//                         shareProfile(url); // mobile
//                       } else {
//                         setShareOpen(true); // desktop modal
//                       }
//                     }}
//                   >
//                     <img src={ShareIcon} alt="share" className="share-icon" />
//                   </div>
//                 </div>
//                 {commentInputPostId === post?._id && (
//                   <div className="feed-text">
//                     <TextArea
//                       className="post-comment-textArea"
//                       style={{
//                         backgroundColor: "#251e3f",
//                         borderRadius: "5px",
//                       }}
//                       onChange={(e) => setComment(e.target.value)}
//                     />
//                     <Button
//                       className="Fill-button-small mt-2"
//                       style={{ width: "200px" }}
//                       onClick={() => handleCommentPost(post?._id, comment)}
//                     >
//                       Submit
//                     </Button>
//                   </div>
//                 )}
//               </div>
//             );
//           })}

//         {/* Share Modal */}
//         <ShareModal
//           open={shareOpen}
//           onClose={() => setShareOpen(false)}
//           url={`${window.location.origin}/profile/${profile?._id}`}
//         />
//       </section>
//     </Main>
//   );
// }

// export default ConnectionProfileSec;

import React, { useEffect, useState } from "react";
import BreadcrumbArrow from "../../assets/images/breadcrumb-image-arrow.svg";
import ProfileImage from "../../assets/images/profile-image.png";
import GammingHeadIcon from "../../assets/images/game-rank-icon/gamming-headshot.svg";
import CommentedIcon from "../../assets/images/game-rank-icon/commented-icon.svg";
import FifaIcon from "../../assets/images/game-rank-icon/fifa-ball-icon.svg";
import Callicon from "../../assets/images/game-rank-icon/call-of-ducty-icon.svg";
import { Breadcrumb, Button, Col, Input, Modal, Row } from "antd";
import { shareProfile } from "../../utils/share";
import ChessIcon from "../../assets/images/game-rank-icon/chess-icon.svg";
import Tiktokicon from "../../assets/images/social-icon/tiktok-icon.svg";
import Facebookicon from "../../assets/images/social-icon/facebook-icon.svg";
import Instagramicon from "../../assets/images/social-icon/instagram-icon.svg";
import Twittericon from "../../assets/images/social-icon/twitter-icon.svg";
import ShareIcon from "../../assets/images/share-icon.svg";
import { Ellipsis, Heart, MessageCircle } from "lucide-react";
import { useNavigate, useParams } from "react-router";
import Main from "../../components/layout/Main";
import { useAuth } from "../../context/AuthContext";
import { isValidUrl } from "../../helper/functions";
import { Severty, ShowToast } from "../../helper/toast";
import TextArea from "antd/lib/input/TextArea";
import { CloseOutlined, HeartFilled } from "@ant-design/icons";
import moment from "moment";
import ShareModal from "../../components/ShareModal";
import { Link } from "react-router-dom";
import ThrophieImage from "../../assets/images/trofies-image.svg";
import GoldImage from "../../assets/images/gold-button-image.svg";
import UniversalShareModal from "../../components/UniversalShareModal";

function ConnectionProfileSec() {
  // --------- constants ----------
  const navigate = useNavigate();
  const [trophies, setTrophies] = useState([]);
  const {
    getProfileById,
    followUser,
    unfollowUser,
    getPosts,
    likePost,
    createComment,
    getActivityLog,
    getTrophies,
  } = useAuth();
  const [profile, setProfile] = useState();
  const [commentInputPostId, setCommentInputPostId] = useState(false);
  const [comment, setComment] = useState("");
  const [posts, setPosts] = useState([]);
  const [shareOpen, setShareOpen] = useState(false);
  const [activityLogs, setActivityLogs] = useState([]);
  const [openModalName, setOpenModalName] = useState(null);

  const { id } = useParams();

  // --------- handlers -----------
  const fetchProfile = async (id) => {
    try {
      const response = await getProfileById(id);
      if (response.status === 200) {
        setProfile(response.data);
      }
      const trohpiesResponse = await getTrophies(id);
      if (trohpiesResponse.status === 200) {
        setTrophies(trohpiesResponse?.data?.data?.data);
      }
      const result = await getPosts(id);
      if (result.status === 200) setPosts(result.data.data);
      const activityResponse = await getActivityLog({
        userId: id,
        type: "latest",
      });
      if (activityResponse.status === 200) {
        setActivityLogs(activityResponse?.data?.data?.data);
      }
    } catch (error) {
      console.log("Error Ocurred when fetch profile", error);
    }
  };

  //---------- follow user ------------
  const handleFollow = async (id, isFollowing) => {
    try {
      let response;
      if (isFollowing) {
        response = await unfollowUser(id);
      } else {
        response = await followUser(id);
      }
      if (response.status === 200) {
        fetchProfile(id);
      }
    } catch (error) {
      console.log("Error Ocurred when fetch profile", error);
    }
  };

  // ---------- Handle comment ----------
  const handleCommentPost = async (postId, content) => {
    try {
      const response = await createComment(postId, content);
      if (response.status === 200) {
        ShowToast(response.message, Severty.SUCCESS);
        fetchProfile(id);
        setCommentInputPostId(false);
        setComment("");
      }
    } catch (error) {
      console.log("error in handle comment post -->", error);
      ShowToast(error.message, Severty.ERROR);
    }
  };

  // ---------- Handle Like -------------
  const handleLikePost = async (postId) => {
    // console.log("postId-->", postId);
    // setIsLiked((prev) => !prev);
    try {
      const response = await likePost(postId);
      if (response.status === 200) {
        fetchProfile(id);
      }
    } catch (error) {
      console.log("error in handle like post -->", error);
      ShowToast(error.message, Severty.ERROR);
    }
  };

  // --------- use effect ----------
  useEffect(() => {
    fetchProfile(id);
  }, [id]);

  // --------- Go to the specifi post -----------
  useEffect(() => {
    if (window.location.hash) {
      const postId = window.location.hash.replace("#", "");

      // Wait for posts to load
      setTimeout(() => {
        const element = document.getElementById(postId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 300);
    }
  }, [posts]);

  return (
    <>
      <Main>
        <div className="section-main">
          <section className="profile-section">
            <h1 className="sidebar-title">Profile</h1>
            <Row gutter={[16, 16]}>
              <Col span={24} md={12} lg={14} xl={16}>
                <div className="profile-box-main">
                  <div className="profile-top-card-main">
                    <div className="profile-top-card-left">
                      {/* Profile Picture & Stats */}
                      <div className="profile-header">
                        <div className="avatar-wrapper">
                          <img
                            src={
                              isValidUrl(profile?.profilePic)
                                ? profile?.profilePic
                                : ProfileImage
                            }
                            alt="avatar"
                          />
                        </div>
                        <div className="stats">
                          <div
                            className="stat-block follwers-stat-block"
                            onClick={() =>
                              navigate(`/connections?userId=${id}`)
                            }
                          >
                            <h6 className="count">{profile?.followersCount}</h6>
                            <span className="label">Followers</span>
                          </div>
                          <div
                            className="stat-block follwers-stat-block"
                            onClick={() =>
                              navigate(`/connections?userId=${id}`, {
                                state: { data: "following" },
                              })
                            }
                          >
                            <h6 className="count">{profile?.followingCount}</h6>
                            <span className="label">Following</span>
                          </div>
                          <div className="stat-block">
                            <h6 className="count">{posts?.length}</h6>
                            <span className="label">Posts</span>
                          </div>
                        </div>
                      </div>
                      {/* Name and Handle */}
                      <div className="username">
                        <h6 className="name">
                          {profile?.name} <span>#{profile?.rankId}</span>
                        </h6>
                        <span className="handle">{profile?.username}</span>
                      </div>
                      {/* Location */}
                      <div className="profile-location">
                        <div>{profile?.location}</div>
                      </div>
                      {/* Action Buttons */}
                      <div className="profile-actions">
                        <Button
                          className="btn-fill-small active"
                          onClick={() =>
                            handleFollow(profile?._id, profile?.IsFollowing)
                          }
                        >
                          {profile?.IsFollowing ? "Unfollow" : "Follow"}
                        </Button>
                        <Button
                          className="btn-fill-small"
                          onClick={() =>
                            navigate("/chat", { state: { profile } })
                          }
                        >
                          Message
                        </Button>
                        <Button
                          className="btn-fill-small"
                          onClick={() => setShareOpen(true)}
                        >
                          Share Profile
                        </Button>
                      </div>
                      {/* Social Links */}
                      <div className="profile-actions">
                        {profile?.xLink?.trim() !== "" && (
                          <Link to={profile?.xLink} className="btn-social">
                            <img src={Twittericon} alt="twitter" />
                          </Link>
                        )}
                        {profile?.instagramLink?.trim() !== "" && (
                          <Link
                            to={profile?.instagramLink}
                            className="btn-social"
                          >
                            <img src={Instagramicon} alt="instagram" />
                          </Link>
                        )}
                        {profile?.facebookLink?.trim() !== "" && (
                          <Link
                            to={profile?.facebookLink}
                            className="btn-social"
                          >
                            <img src={Facebookicon} alt="facebook" />
                          </Link>
                        )}
                        {profile?.tikTokLink?.trim() !== "" && (
                          <Link to={profile?.tikTokLink} className="btn-social">
                            <img src={Tiktokicon} alt="tiktok" />
                          </Link>
                        )}
                      </div>
                    </div>

                    {/* Right Side */}
                    <div className="profile-top-card-right">
                      <div className="profile-top-rankbox">
                        <div
                          className="profile-top-rankbox-inner"
                          style={{ cursor: "pointer" }}
                          onClick={() => setOpenModalName("trophiesModal")}
                        >
                          <h6>Trophies</h6>
                          <p>{trophies?.length || "N/A"}</p>
                        </div>
                        <div className="profile-top-rankbox-inner">
                          <h6>Rank</h6>
                          <p>{profile?.rank}</p>
                        </div>
                        <div className="profile-top-rankbox-inner">
                          <h6>Gender</h6>
                          <p>{profile?.gender}</p>
                        </div>
                      </div>

                      <div className="game-rank-list">
                        <div className="game-rank-list-header">
                          <h6>Game Ranks</h6>
                          <Link>View All</Link>
                        </div>

                        {/* Example Games */}
                        <div className="game-row">
                          <div className="game-info">
                            <img src={Callicon} alt="call of duty" />
                            <div>
                              <h6 className="game-title">Call of Duty</h6>
                              <span className="game-level">Master Level</span>
                            </div>
                          </div>
                          <h6 className="game-rank">#12</h6>
                        </div>

                        <div className="game-row">
                          <div className="game-info">
                            <img src={FifaIcon} alt="fifa 2025" />
                            <div>
                              <h6 className="game-title">FIFA 2025</h6>
                              <span className="game-level">Elite Division</span>
                            </div>
                          </div>
                          <h6 className="game-rank">#42</h6>
                        </div>

                        <div className="game-row">
                          <div className="game-info">
                            <img src={ChessIcon} alt="chess" />
                            <div>
                              <h6 className="game-title">Chess</h6>
                              <span className="game-level">Diamond League</span>
                            </div>
                          </div>
                          <h6 className="game-rank">#42</h6>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Feed Posts */}
                  <div className="feed-post_all">
                    {posts.map((post, index) => (
                      <div className="feed-post" key={index}>
                        <div className="post-header">
                          <div className="post-user">
                            <img
                              src={post?.profilePic || ProfileImage}
                              alt="john doe"
                            />
                            <div>
                              <h6 className="post-name">{post?.name}</h6>
                              <span className="post-date">
                                {moment(post?.updated_at).format("MMM Do YYYY")}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="feed-images">
                          {post.mediaFiles.map((file, index) => {
                            const isImage =
                              /\.(jpg|jpeg|png|gif|webp|svg)$/i.test(file);
                            const isVideo = /\.(mp4|mov|webm|ogg)$/i.test(file);

                            return (
                              <div key={index}>
                                {isImage && (
                                  <img
                                    src={file}
                                    alt="media"
                                    style={{
                                      height: "200px",
                                      objectFit: "cover",
                                    }}
                                  />
                                )}

                                {isVideo && (
                                  <video
                                    src={file}
                                    controls
                                    style={{
                                      height: "200px",
                                      objectFit: "cover",
                                    }}
                                  />
                                )}
                              </div>
                            );
                          })}
                        </div>
                        <div className="feed-text">{post?.body}</div>
                        {post?.allowComments && (
                          <div className="games-connections-input">
                            <img src={CommentedIcon} alt="activity2" />
                            {/* <Input className="connections-input" /> */}
                          </div>
                        )}
                        <div className="post-reactions">
                          <div className="reaction-group">
                            <div
                              className="reaction"
                              style={{ cursor: "pointer" }}
                              onClick={() => handleLikePost(post?._id)}
                            >
                              {post?.isLiked ? (
                                <HeartFilled
                                  style={{ fontSize: 22, color: "red" }}
                                />
                              ) : (
                                <Heart />
                              )}
                              <span>{post?.totalLikes}</span>
                            </div>
                            <div
                              className="reaction"
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                setCommentInputPostId((prev) =>
                                  prev === post?._id ? null : post?._id
                                )
                              }
                            >
                              <MessageCircle />
                              <span>{post?.totalComments}</span>
                            </div>
                          </div>
                          <img
                            // onClick={() => setIsShareModalOpen(true)}
                            onClick={() => {
                              const url = `${window.location.origin}/profile/${profile?._id}/#${post._id}`;

                              if (navigator.share) {
                                shareProfile(url); // mobile
                              } else {
                                setShareOpen(true); // desktop modal
                              }
                            }}
                            src={ShareIcon}
                            alt="share"
                            className="share-icon"
                          />
                        </div>
                        {commentInputPostId === post?._id && (
                          <div className="feed-text">
                            <TextArea
                              className="post-comment-textArea"
                              style={{
                                backgroundColor: "#251e3f",
                                borderRadius: "5px",
                              }}
                              onChange={(e) => setComment(e.target.value)}
                            />
                            <Button
                              className="Fill-button submit-button-mainjhjh"
                              onClick={() =>
                                handleCommentPost(post?._id, comment)
                              }
                            >
                              Submit
                            </Button>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </Col>

              {/* Activity Log */}
              <Col span={24} md={12} lg={10} xl={8}>
                <div className="game-rank-list">
                  <div className="game-rank-list-header">
                    <h6>Activity Log</h6>
                    <Link>View All</Link>
                  </div>
                  <div className="active-log-table">
                    <ul>
                      {activityLogs && activityLogs.length > 0 ? (
                        activityLogs?.map((activity, i) => (
                          <li key={i}>
                            <div className="active-log-leftbar">
                              <h6>{activity?.tournamentName}</h6>
                              <h5> {activity?.result}</h5>
                            </div>
                            <div className="active-log-rightbar">
                              <p>
                                {moment(activity?.date).format("DD MMM YYYY")}
                              </p>
                              <h5>
                                {activity?.trophy === "Gold"
                                  ? "🥇"
                                  : activity?.trophy === "Silver"
                                  ? "🥈"
                                  : "🥉"}{" "}
                                {activity?.trophy}
                              </h5>
                            </div>
                          </li>
                        ))
                      ) : (
                        <p>No activity logs found</p>
                      )}
                    </ul>
                  </div>
                </div>
              </Col>
            </Row>
          </section>
        </div>
      </Main>

      {/* Share Modal */}
      <UniversalShareModal
        open={shareOpen}
        onClose={() => setShareOpen(false)}
        url={window.location.href}
      />
      <Modal
        open={openModalName === "trophiesModal"}
        className="new-thropies-modal custome_mail_modal "
        footer={null}
        closable={false}
      >
        <div className="thropies-modal-header">
          <h4>Trophies</h4>

          <span
            className="close-btn120"
            style={{ cursor: "pointer" }}
            onClick={() => setOpenModalName(null)}
          >
            <CloseOutlined />
          </span>
        </div>

        <div className="panel game-ranks">
          {trophies && trophies.length > 0 ? (
            trophies.map((trophie, index) => {
              return (
                <div className="game-row" key={index}>
                  <div className="game-info">
                    <img src={ThrophieImage} alt="call of duty" />
                    <div>
                      <h6 className="game-title">
                        {trophie?.tournamentName?.toUpperCase()}
                      </h6>
                      <span className="game-level">
                        {trophie?.participantType}
                      </span>
                    </div>
                  </div>
                  <h6 className="game-rank game-rank__new">
                    <img src={GoldImage} alt="call of duty" /> {trophie?.trophy}
                  </h6>
                </div>
              );
            })
          ) : (
            <p>No trophies available</p>
          )}
        </div>
        <div></div>
      </Modal>
    </>
  );
}

export default ConnectionProfileSec;
